import { Alert, Typography, styled } from "@mui/material";

import { Column, Row } from "@citrine/atoms/layout";

// The assistant's turn has no bubble — it's full-width content on the panel, so
// rich markdown/tables/alerts have room and the prose carries it (ChatGPT/Claude
// style). The user's turn is the shared grey UserBubble (see chat.tsx).
export const AssistantTurn = styled("div")(({ theme }) => ({
  alignSelf: "stretch",
  color: theme.palette.text.primary,
  maxWidth: "100%",
}));

export const MessageList = styled(Column)(({ theme }) => ({
  background: theme.palette.common.white,
  // Fill the panel between header and input and scroll internally, so the
  // scrollbar sits flush at the panel's right edge (minHeight: 0 lets a flex
  // child shrink below its content height so it actually scrolls).
  flex: 1,
  gap: theme.spacing(1.5),
  minHeight: 0,
  overflowY: "auto",
  padding: theme.spacing(2),
  scrollBehavior: "smooth",
}));

// Errors are system conditions, not the agent's content, so they render as
// standalone (standard) Alerts outside the message bubble — spanning the full
// panel width to read as a system-level notice rather than a chat turn.
export const ErrorAlert = styled(Alert)({
  alignSelf: "stretch",
});

// A runtime event (tool call, retrieval, step progress) is process, not
// content — a quiet status line that recedes beneath the prose rather than a
// boxed chip. The agent glyph (chat.sx) ties it to the Omni/agent vocabulary.
export const EventLine = styled(Row)(({ theme }) => ({
  gap: theme.spacing(0.75),
  margin: theme.spacing(1, 0, 0.25),
}));

export const Text = styled(Typography)({ wordBreak: "break-word" });
